import Seo from "@/components/seo/Seo";

export default function NotFoundPage() {
  return (
    <main className="min-h-screen bg-[#0284FC] flex items-center justify-center px-6 text-center">
      <Seo title="Page introuvable – Vinylux" description="Cette page n'existe pas." path={window.location.pathname} noindex />
      <div>
        <p className="text-white/60 font-semibold mb-3">Erreur 404</p>
        <h1 className="text-4xl font-black text-white mb-6">Cette page n'existe pas</h1>
        <a href="/" className="inline-flex bg-white text-[#0284FC] font-bold px-7 py-3 rounded-full">Retour à l'accueil</a>
      </div>
    </main>
  );
}
